// "Offers on this bill" for the Express till: the markdowns and the pricing
// engine's promotions the bag lines already carry, one row per offer with what
// it saves. Pure: it reads the cart and never prices anything again.
import { billRuleIds, isActiveLine, lineBillDiscount, lineRuleIds } from "./billTotals";
import { dealLabel } from "./markdowns";

const num = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};
const round2 = (v) => Math.round((v + Number.EPSILON) * 100) / 100;

// dealOf(productId) gives the markdown deal ({price, was, markdown}) or null.
export function billOffers(cart, dealOf) {
  const billIds = billRuleIds(cart);
  const lineIds = lineRuleIds(cart);
  const rows = new Map();
  const add = (key, name, kind, saving) => {
    if (!(saving > 0)) return;
    const row = rows.get(key) || { key, name, kind, lines: 0, saving: 0 };
    row.lines += 1;
    row.saving = round2(row.saving + saving);
    rows.set(key, row);
  };
  (cart?.items || []).forEach((line) => {
    if (!isActiveLine(line) || line.isReturn || num(line.weight) < 0) return;
    const qty = Math.abs(num(line.weight));
    const deal = typeof dealOf === "function" ? dealOf(line.productId) : null;
    if (deal?.markdown && deal.was > deal.price) {
      add(`md:${deal.markdown.id || dealLabel(deal)}`, dealLabel(deal).split(" · ")[0] || "Marked down", "markdown", round2((deal.was - deal.price) * qty));
    }
    const manual = lineBillDiscount(line, billIds) + lineBillDiscount(line, lineIds);
    const offer = round2(num(line.discount) - manual);
    if (line.discountName && offer > 0) add(`pr:${line.mPricingruleId || line.discountName}`, line.discountName, "offer", offer);
  });
  return [...rows.values()].sort((a, b) => b.saving - a.saving);
}

export const offersTotal = (offers) => round2((offers || []).reduce((s, o) => s + o.saving, 0));
